import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';

import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import Headposture from './component/headposture';
import Shoulderposture from './component/shoulderposture';
import Thoracicposture from './component/thoracic';
import Lumbarposture from './component/lumbar';
import Pelvisposture from './component/pelvis';
import Kneeposture from './component/knee';
import Feetposture from './component/feet';
import Rhythmposture from './component/rhythm';
import Abbreviation from './component/abbreviation';

import {  
   allStudents
} from 'Actions';

function TabContainer({ children }) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}

class mskposture extends Component {
   
   constructor(props) {
      
      super(props);
         this.state = {
            student: '',  
            activeIndex: 0,          
         };      
   
   }

    UNSAFE_componentWillMount() {
		this.props.allStudents();
	}

    handleChange(event, value) {
        this.setState({ activeIndex: value });
    }

   
    render() {
      const { match, studentlists, loading} = this.props;
       
      const allstudent=studentlists.map((stdval) => {  
            return {
               label: stdval.student,  
               value: stdval.uudID
            }
      });

      
       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>MSK Posture | {AppConfig.appTitle}</title>
                <meta name="description" content="Reactify Sass Dashboard" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.mskpostureheading" />} match={match} />
             <div className="row">
                <div className="col-sm-12 col-md-12">
                    <RctCollapsibleCard>
                        
                            <Tabs value={this.state.activeIndex} onChange={(e, value) => this.handleChange(e, value)} 
                                textColor="primary"
                                indicatorColor="primary"
                                centered>
                                <Tab label="Head" />
                                <Tab label="Shoulders" />
                                <Tab label="Thoracic Spine" />
                                <Tab label="Lumbar Spine" />
                                <Tab label="Pelvis" />
                                <Tab label="Knee Posture" />
                                <Tab label="Feet" />
                                <Tab label="Glenohumeral Rhythm" />
                                <Tab label="Abbreviation" />
                            </Tabs>
                        
                        {this.state.activeIndex === 0 && <TabContainer> <Headposture /> </TabContainer>}
                        {this.state.activeIndex === 1 && <TabContainer> <Shoulderposture /> </TabContainer>}
                        {this.state.activeIndex === 2 && <TabContainer> <Thoracicposture /> </TabContainer>}
                        {this.state.activeIndex === 3 && <TabContainer> <Lumbarposture /> </TabContainer>}
                        {this.state.activeIndex === 4 && <TabContainer> <Pelvisposture /> </TabContainer>}
                        {this.state.activeIndex === 5 && <TabContainer> <Kneeposture /> </TabContainer>}
                        {this.state.activeIndex === 6 && <TabContainer> <Feetposture /></TabContainer>}
                        {this.state.activeIndex === 7 && <TabContainer> <Rhythmposture /> </TabContainer>}
                        {this.state.activeIndex === 8 && <TabContainer> <Abbreviation /> </TabContainer>}
                    </RctCollapsibleCard>
                </div>    
            </div>
               
             
          </div>
       )
    }
 }


const mapStateToProps = ({mostlyused}) => {     
   const { studentlists, loading } = mostlyused;
	return { studentlists, loading };
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
}

export default connect(mapStateToProps, {
    allStudents
})(mskposture); 